import { render, staticRenderFns } from "./ColorCheckbox.vue?vue&type=template&id=0c6ae5da&scoped=true"
import script from "./ColorCheckbox.vue?vue&type=script&lang=js"
export * from "./ColorCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ColorCheckbox.vue?vue&type=style&index=0&id=0c6ae5da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ae5da",
  null
  
)

export default component.exports